export default {
  data() {
    return {
      isSelect: false,
    };
  },
  props: ['option', 'componentSelect', 'index'],
  watch: {
    componentSelect(n) {
      if (n === this.option.componentId) this.isSelect = true;
      else this.isSelect = false;
    },
  },
  render(createElement) {
    const self = this;
    if (self?.option?.elements?.length) {
      const classes = ['go-report-section'];
      if (self.isSelect) classes.push('component_select');
      return createElement(
        'div',
        {
          class: classes,
          on: {
            click() {
              self.isSelect = true;
              self.$emit('selectBody', self.option.componentId, '', '');
            },
          },
        },
        self?.option?.elements.map(function (item) {
          switch (item.elementType || item.element_type) {
            case 'heading':
              return createElement('h2', `${self.index + 1}. ${item.content}`);
            case 'entry':
              break;
            case 'list':
              if (item.contents?.length > 0) {
                return createElement(
                  'ul',
                  {
                    class: ['go-report-list-decimal'],
                  },
                  item.contents.map(function (obj) {
                    return createElement(
                      'li',
                      {
                        on: {
                          click() {
                            self.$root.$emit('select-reference-document', obj.docId);
                          },
                        },
                      },
                      [
                        createElement('strong', { class: ['go-report-reference-title'] }, obj.title),
                        // createElement('a', { class: ['go-report-reference-link'] }, `https://goover.ai/detail-feed/${obj.doc_id}`),
                        createElement(
                          'a',
                          {
                            class: ['go-report-reference-link'],
                            attrs: {
                              href: obj.url.startsWith('go-public') ? window.location.origin + '/report-detail/' + obj.url : obj.url,
                            },
                            on: {
                              click: event => {
                                event.preventDefault();
                                if (obj.url.startsWith('/opt')) {
                                  window.open(window.location.origin + '/' + obj.url?.replace(/^\/opt\/deepsignal\//, ''));
                                } else if (obj.url.startsWith('go-public')) {
                                  window.open(window.location.origin + '/report-detail/' + obj.url);
                                } else {
                                  window.open(obj.url);
                                }
                              },
                            },
                          },
                          obj.url.startsWith('go-public') ? window.location.origin + '/report-detail/' + obj.url : obj.url
                        ),
                      ]
                    );
                  })
                );
              }
              break;
            default:
              return createElement('p', item.content);
          }
        })
      );
    }
  },
};
